import proxy from "@/api/proxy"
import localstorage from "@/store/localstorage"
import axios from "axios"

const sessionLifetime = 1000 * 60 * 30
let pendingSession: Promise<void> | null = null

// Calls axios directly (not BaseApiService) because BaseApiService calls ensureSession before every request
async function createSession() {
  const response = await axios.put("Security/Session/Create", {}, { baseURL: proxy.SecurityV1, headers: { OS: "Web", "Content-Type": "application/json", Accept: "application/json" } })
  localstorage.SaveSessionToken(response.data)
  localstorage.SaveSessionTokenTime(Date.now().toString())
}

const sessionService = {
  // Creates a session when there is none, it's older than 30 minutes, or force is set (e.g. the server rejected it).
  // Concurrent callers share one in-flight request.
  ensureSession(force = false): Promise<void> {
    const epochTime = localstorage.GetSessionTokenTime()
    const isFresh = !!localstorage.getToken() && !!epochTime && Date.now() - +epochTime < sessionLifetime
    if (isFresh && !force) return Promise.resolve()

    if (!pendingSession) {
      pendingSession = createSession().finally(() => {
        pendingSession = null
      })
    }
    return pendingSession
  },
}
export default sessionService
